export default {
  cluster: {
    id: null,
    items: {},
    loading: false,
    outfits: {},
    page: 1,
  },
  fps: [],
  items: [],
  defaultSort: {
    page: 1,
    column: 'updated_at',
    order: 'descending',
    limit: 25,
  },
  sort: {
    page: 1,
    column: 'updated_at',
    order: 'descending',
    limit: 25,
    filter: '',
  },
  more: true,
  loading: false,
  logs: {
    id: null,
    items: [],
    loading: false,
  },
  total: 0,
};
